import { createFileRoute, redirect } from '@tanstack/react-router'
import { FaInfoCircle } from 'react-icons/fa'

import { PageLayout } from '@/components/layouts'
import { DESCRIPTIONS, MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'
import { ContractCreateHeader } from '@/routes/_protected/$tenantKey/settings/contracts/-components/ContractCreateHeader'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/create'
)({
  meta: () => [{ title: MENU.NEW_REGISTRATION }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合は契約一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/contracts`
      })
    }
  },
  component: ContractCreatePage
})

function ContractCreatePage() {
  const { tenantKey } = Route.useParams()
  return (
    <PageLayout>
      {/* 直下の ContractCreateHeader は -mt-4 で 16px 上に食い込む sticky（背景色付き）なので、案内文の下余白は mb-4 で相殺する（mb-2 だと上半分が隠れる） */}
      <div className="mb-4 text-orange-5">
        <FaInfoCircle className="mr-1 inline-block align-middle" />
        <span className="inline-block align-middle">
          {DESCRIPTIONS.SELECT_CONTRACT_TYPE2}
        </span>
      </div>
      <ContractCreateHeader tenantKey={tenantKey} className="mb-4" />
    </PageLayout>
  )
}
